import { browserLogger } from '@widget/utils/datadog';

type ModalLoggerContext = {
  widgetId: string;
  firstStepName: string;
  currentStepId: string;
};

type InitialProps = Partial<ModalLoggerContext>;

export function initModalLoggerContext({ widgetId, firstStepName, currentStepId }: InitialProps) {
  browserLogger.setContextProperty('widgetModal', {
    widgetId: widgetId ?? 'unknown',
    firstStepName: firstStepName ?? 'unknown',
    currentStepId: currentStepId ?? 'unknown',
  });
}

export function removeModalLoggerContext() {
  browserLogger.removeContextProperty('widgetModal');
}

export const setModalLoggerContextProperty = <T extends keyof ModalLoggerContext>(
  propName: T,
  value: ModalLoggerContext[T],
) => {
  try {
    const widgetModalContext = browserLogger.getContextProperty(
      'widgetModal',
    ) as ModalLoggerContext;
    browserLogger.setContextProperty('widgetModal', { ...widgetModalContext, [propName]: value });
  } catch {
    /* empty */
  }
};
